import React from "react";
import { FontStyles } from "../../utils/font-styles";
import { ButtonLink } from "../../components/buttons/button-link";
import { TextLink } from "../../components/text-link";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";

interface ValuationFormSubmittedScreenProps {
  isLoggedIn: boolean;
}

export const ValuationFormSubmittedScreen: React.FC<ValuationFormSubmittedScreenProps> = ({ isLoggedIn }) => {
  return (
    <div className="flex flex-col gap-6.5 md:gap-7.5 p-6 bg-neutral-white w-full">
      {/* Header and text container */}
      <div className="flex flex-col gap-3.5">
        {/* Title */}
        <h3 className={`${FontStyles.h5} font-medium leading-none md:leading-none`}>Valuation request submitted</h3>

        {/* Body text with inline links */}
        <p className={`${FontStyles["body-l"]} text-slate whitespace-pre-line`}>
          {`Thank you! We have now passed on your valuation enquiry to your chosen solicitor estate agent firms. They will contact you directly via phone or email to fully discuss the next steps in getting your pre-sale home valuation.

In the meantime, have a look at our `}
          <TextLink href="/advice" className="font-medium">
            free advice section
          </TextLink>
          {`, or `}
          <TextLink href="/" className="font-medium">
            head back to our homepage
          </TextLink>
          {` to search for your dream home. You might also be interested in:`}
        </p>
      </div>

      {/* Action buttons grid */}
      <div className="flex flex-col gap-3.5 md:gap-4">
        {/* Row 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ButtonLink
            label="Search for properties"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-magnifying-glass" />}
            href="/"
          />
          {isLoggedIn ? (
            <ButtonLink
              label="Search by school catchment"
              colorVariant="secondary"
              variant="outlined"
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-chalkboard-user" />}
              href="/#schools"
            />
          ) : (
            <ButtonLink
              label="Create a My ESPC account"
              colorVariant="secondary"
              variant="outlined"
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-circle-user" />}
              href="/users/register"
            />
          )}
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ButtonLink
            label="Finding a home"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-house-heart" />}
            href="/advice/buying"
          />
          <ButtonLink
            label="Selling a home"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-sign-hanging" />}
            href="/advice/selling"
          />
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ButtonLink
            label="ESPC Mortgages"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-coins" />}
            href="/services/mortgages"
          />
          <ButtonLink
            label="Mortgage calculator"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-calculator" />}
            href="/advice/tools/mortgage-calculator"
          />
        </div>

        {/* Row 4 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ButtonLink
            label="Ask the Expert drop-ins"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-comments-question" />}
            href="/services/experts"
          />
          <ButtonLink
            label="Events"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-calendar" />}
            href="/services/events"
          />
        </div>
      </div>
    </div>
  );
};
